/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useList, useNotify, useVersion, useQueryWithStore } from "react-admin";
import { logError } from "../utils/appUtils";
import { isEmpty, keyBy } from "lodash";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const looksLikeIndexName = (s) =>
  typeof s === "string" && /^.*By[A-Z].*/.test(s); // crude but works for AppSync @key names

const parseSortField = (field) => {
  if (!field || typeof field !== "string") return null;
  if (field.trim().startsWith("{")) {
    try {
      return JSON.parse(field);
    } catch {
      return null;
    }
  }
  return null;
};

const resourceNameMap = {
  inventories: "inventorys",
  carrierReloadYards: "carrierUserReloadYardCarriers",
};

function getResourceName(name) {
  return resourceNameMap[name] ? resourceNameMap[name] : name;
}

export const useSearchableList = (props) => {
  const {
    basePath,
    defaultSearchFilter,
    defaultFilter,
    defaultPerPage,
    resource,
    defaultSort,
  } = props;
  const notify = useNotify();
  const version = useVersion();

  const [payload, setPayload] = useState({});
  const { data, error, loaded, loading, total } = useQueryWithStore({
    type: "getList",
    resource,
    payload,
  });
  if (error) {
    const newError = { ...error, data: payload };
    logError("utils:useSearchableList:useQueryWithStore:", newError, notify);
  }

  const listContext = useList({
    ...props,
    data: data || [],
    ids: data?.map((itm) => itm.id) || [],
    loading,
    total,
    sort: defaultSort,
    perPage: defaultPerPage,
  });

  useEffect(() => {
    debugger;
    const sortQuery = JSON.parse(defaultSort.field);
    keyQueryFetch(sortQuery.key, defaultSort.order);
  }, [version]);

  useEffect(() => {
    debugger;
    listContext.page = 1;
    listContext.setPage(1);
    // defaultFilter changes when a caller swaps the key-mode query itself
    // (e.g. the carrier-user tabs, one GSI prefix per tab) — a new query's
    // pages have nothing to do with the old one's nextToken chain.
  }, [listContext.perPage, listContext.filterValues, defaultFilter]);

  useEffect(() => {
    debugger;
    refetch();
  }, [
    listContext.page,
    listContext.perPage,
    listContext.filterValues,
    listContext.currentSort,
    defaultFilter,
  ]);

  const refetch = () => {
    const parsed = parseSortField(listContext.currentSort?.field);
    const order = listContext.currentSort?.order || "ASC";

    // KEY MODE if we have a key in sort spec and we’re not actively searching
    const wantKeyMode = !!parsed?.key && isEmpty(listContext.filterValues);

    if (wantKeyMode) {
      if (!defaultFilter) {
        setPayload({});
        return;
      }
      keyQueryFetch(parsed.key, order.toUpperCase());
      return;
    }

    // SEARCH MODE
    // Prefer the explicit "search" field from the JSON sort, otherwise take the raw field
    let searchSortField = parsed?.search ?? listContext.currentSort?.field;

    // Guard: never send an index name as a sortable field to search
    if (looksLikeIndexName(searchSortField)) {
      searchSortField = undefined; // let backend default or add your own fallback e.g. "createdAt"
    }

    searchableFetch(searchSortField, order);
  };

  const keyQueryFetch = (queryBy, order) => {
    setPayload({
      filter: { [queryBy]: { ...defaultFilter } },
      pagination: { page: listContext.page, perPage: listContext.perPage },
      sort: { field: queryBy, order: order },
    });
    debugger;
  };

  const searchableFetch = (sortBy, order = "ASC") => {
    const searchKey =
      "search" + capitalizeFirstLetter(getResourceName(resource));
    const input = {
      filter: {
        ...listContext.filterValues,
        [searchKey]: { ...(defaultSearchFilter || {}) },
      },
      pagination: { page: listContext.page, perPage: listContext.perPage },
    };

    if (typeof sortBy === "string" && sortBy.length) {
      // RA -> dataProvider will lowercase for search internally if needed
      input.sort = { field: sortBy, order };
    }
    setPayload(input);
  };

  const finalData = data ? keyBy(data, "id") : {};
  const finalIds = data ? data.map((itm) => itm.id) : [];

  return {
    ...listContext,
    data: finalData,
    ids: finalIds,
    filter: payload.filter,
    total,
    error,
    loaded,
    loading,
    basePath,
    resource,
    payload,
  };
};
